import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-picture-view',
    templateUrl: './picture-view.component.html',
    styleUrls: ['./picture-view.component.scss'],
    standalone: false
})
export class PictureViewComponent implements OnInit {

  url = '';
  title = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
  ) { }

  ngOnInit() {
    this.url = this.data.url;
    this.title = this.data.title;
  }

}
